export enum ColorPicker {
    C95AAE6 = '#95AAE6',
    C63CFC7 = '#63CFC7',
    CE47BCC = '#E47BCC',
    CDDC79A = '#DDC79A',
    C9ECA78 = '#9ECA78',
    C65BEE5 = '#65BEE5',
    CF0AA80 = '#F0AA80',
    CC6D763 = '#C6D763',
    CAC88EE = '#AC88EE',
    CC3BE7A = '#C3BE7A',
    C8099E1 = '#8099E1',
    C55C6BC = '#55C6BC',
    CDF6AC2 = '#DF6AC2',
    CD7BC86 = '#D7BC86',
    C8BC067 = '#8BC067',
    C57B2E0 = '#57B2E0',
    CEE996E = '#EE996E',
    CBBCF55 = '#BBCF55',
    C9C75EB = '#9C75EB',
    CB8B169 = '#B8B169',
    C6B87D9 = '#6B87D9',
    C47BAAE = '#47BAAE',
    CD658B5 = '#D658B5',
    CCDAE71 = '#CDAE71',
    C77B355 = '#77B355',
    C48A3D7 = '#48A3D7',
    CE8875B = '#E8875B',
    CADC447 = '#ADC447',
    C8A61E4 = '#8A61E4',
    CA9A157 = '#A9A157',
    C5674D0 = '#5674D0',
    C39AEA1 = '#39AEA1',
    CCD47A9 = '#CD47A9',
    CC3A15C = '#C3A15C',
    C62A645 = '#62A645',
    C3A94CE = '#3A94CE',
    CE1744A = '#E1744A',
    C9FB939 = '#9FB939',
    C784FDD = '#784FDD',
    C9C9247 = '#9C9247',
    C4363C7 = '#4363C7',
    C2DA295 = '#2DA295',
    CC6389C = '#C6389C',
    CBA9548 = '#BA9548',
    C4F9936 = '#4F9936',
    C2E86C6 = '#2E86C6',
    CDA633A = '#DA633A',
    C93AF2D = '#93AF2D',
    C683ED6 = '#683ED6',
    C8F8537 = '#8F8537',
    C444444 = '#444444'
}




// WEBPACK FOOTER //
// ./src/app/shared/enums/color-picker.enum.ts